import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { GraduationCap, Lock, Loader2, Eye, EyeOff, Mail } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { login } from '../../lib/auth';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error('Veuillez remplir tous les champs');
      return;
    }
    setLoading(true);
    try {
      const data = await login(email, password);
      toast.success(`Bienvenue, ${data.user.name}`);
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#003366] flex items-center justify-center px-4" data-testid="admin-login-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-[#003366] rounded-xl flex items-center justify-center mx-auto mb-4">
              <GraduationCap className="text-white" size={32} />
            </div>
            <h1 className="font-heading text-2xl font-bold text-[#003366]">Administration CEFAT</h1>
            <p className="text-gray-500 mt-2">Connectez-vous pour acceder au tableau de bord</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-[#003366] font-semibold">Email</Label>
              <div className="relative mt-2">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="pl-10 h-12" placeholder="votre.email@cefat-bs.ci" data-testid="admin-email-input" required />
              </div>
            </div>
            <div>
              <Label htmlFor="password" className="text-[#003366] font-semibold">Mot de passe</Label>
              <div className="relative mt-2">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
                <Input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} className="pl-10 pr-10 h-12" placeholder="Mot de passe" data-testid="admin-password-input" required />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#DC143C] hover:bg-[#B01030] text-white rounded-full py-3 font-semibold" data-testid="admin-login-submit">
              {loading ? <><Loader2 className="mr-2 animate-spin" size={18} />Connexion...</> : 'Se connecter'}
            </Button>
          </form>
          <p className="text-center text-sm text-gray-500 mt-6">
            <a href="/" className="text-[#003366] hover:underline">Retour au site</a>
          </p>
        </div>
      </motion.div>
    </div>
  );
}
